import dayjs, { Dayjs } from 'dayjs';
import { ReactNode } from 'react';
import {
  TX_CUSTOM,
  TX_PAST_YEAR,
  TX_THIS_MONTH,
  TX_THIS_WEEK,
  TX_THIS_YEAR,
  TX_TODAY,
  TxPastDaysNum,
  TxPastMonthsNum,
} from '../../storybook_transifex';

export type TQuickDateOption =
  | 'today'
  | 'this_week'
  | 'past_7_days'
  | 'this_month'
  | 'last_30_days'
  | 'past_3_months'
  | 'past_6_months'
  | 'past_year'
  | 'this_year'
  | 'custom';

export const quickDateOptionsLabelMap: Record<TQuickDateOption, ReactNode> = {
  today: TX_TODAY,
  this_week: TX_THIS_WEEK,
  past_7_days: TxPastDaysNum(7),
  this_month: TX_THIS_MONTH,
  last_30_days: TxPastDaysNum(30),
  past_3_months: TxPastMonthsNum(3),
  past_6_months: TxPastMonthsNum(6),
  past_year: TX_PAST_YEAR,
  this_year: TX_THIS_YEAR,
  custom: TX_CUSTOM,
};

export const quickDateOptions = Object.keys(quickDateOptionsLabelMap).map(
  (key) => ({
    label: quickDateOptionsLabelMap[key as TQuickDateOption],
    value: key,
  })
);

export const quickDateOptionMap: Record<
  TQuickDateOption,
  () => [Dayjs, Dayjs]
> = {
  today: () => [dayjs().startOf('day'), dayjs().endOf('day')],
  this_week: () => [dayjs().startOf('week'), dayjs().endOf('week')],
  past_7_days: () => [
    dayjs().subtract(7, 'days').startOf('day'),
    dayjs().subtract(1, 'days').endOf('day'),
  ],
  this_month: () => [dayjs().startOf('month'), dayjs().endOf('month')],
  last_30_days: () => [
    dayjs().subtract(30, 'days').startOf('day'),
    dayjs().subtract(1, 'days').endOf('day'),
  ],
  past_3_months: () => [
    dayjs().subtract(3, 'months').startOf('month'),
    dayjs().subtract(1, 'month').endOf('month'),
  ],
  past_6_months: () => [
    dayjs().subtract(6, 'months').startOf('month'),
    dayjs().subtract(1, 'month').endOf('month'),
  ],
  past_year: () => [
    dayjs().subtract(1, 'year').startOf('year'),
    dayjs().subtract(1, 'year').endOf('year'),
  ],
  this_year: () => [dayjs().startOf('year'), dayjs().endOf('year')],
  custom: () => [dayjs().subtract(1, 'day'), dayjs().add(1, 'day')],
};

export const getQuickDateSelectValue = (
  value?: [Dayjs, Dayjs]
): TQuickDateOption => {
  if (!value) {
    return 'custom';
    // eslint-disable-next-line no-else-return
  } else {
    // eslint-disable-next-line no-restricted-syntax, guard-for-in
    for (const key in quickDateOptionsLabelMap) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const date = quickDateOptionMap[key as TQuickDateOption]();
      if (
        date?.[0].isSame(value[0], 'date') &&
        date?.[1].isSame(value[1], 'date')
      ) {
        return key as TQuickDateOption;
      }
    }
  }

  return 'custom';
};
